export enum ConfirmProductionScheduleOnDesktopResult {
  CONFIRMED,
  CANCELLED,
  PLAN_ADJUSTMENT_NEEDED
}
